import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2","key":"svg-0"}],["path",{"d":"M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2","key":"svg-1"}],["path",{"d":"M10 14h4","key":"svg-2"}],["path",{"d":"M12 12v4","key":"svg-3"}]]

const IconClipboardPlus = createReactComponent('outline', 'clipboard-plus', 'ClipboardPlus', __iconNode);

export default IconClipboardPlus;